import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DashboardOutlined,
  LogoutOutlined,
  TeamOutlined,
  FolderOpenOutlined,
  SolutionOutlined,
  GoldOutlined,
  DatabaseOutlined,
  FormOutlined,
  SyncOutlined,
  GiftOutlined,
  CalendarOutlined,
  ScheduleOutlined,
  SwapOutlined,
  WalletOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, theme, Avatar, Dropdown } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuClick = (e) => {
    if (e.key === 'signout') {
      navigate('/');
    } else {
      navigate(e.key);
    }
  };



  return (
    <Layout style={{ minHeight: '100vh', fontFamily: 'Poppins, sans-serif' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        collapsedWidth={isMobile ? 0 : 80}
        onCollapse={(isCollapsed) => setCollapsed(isCollapsed)}
        style={{
          background: 'linear-gradient(180deg, #0a1128 0%, #1c2541 100%)',
        }}
      >
        <div style={{ height: 64, margin: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          {collapsed ? (
            <img src="/logo.png" alt="ACCI Logo" style={{ width: 40, height: 40, objectFit: 'contain' }} />
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <img src="/logo.png" alt="ACCI Logo" style={{ width: 40, height: 40, objectFit: 'contain' }} />
              <h1 style={{ color: '#fff', margin: 0, fontSize: '24px', fontWeight: 'bold', letterSpacing: '1px' }}>ACCI</h1>
            </div>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['']}
          onClick={handleMenuClick}
          style={{ background: 'transparent', borderRight: 0 }}
        >
          <Menu.Item key="" icon={<DashboardOutlined className="fs-4" />}>
            Dashboard
          </Menu.Item>
          <Menu.SubMenu key="Users" icon={<TeamOutlined className="fs-4" />} title="MEMBERS">
            <Menu.Item key="otherparticipations" icon={<UserOutlined className="fs-4" />}>
              MEMBER
            </Menu.Item>
            <Menu.Item key="rqlist" icon={<FolderOpenOutlined className="fs-4" />}>
              Archive List
            </Menu.Item>
            <Menu.Item key="visitor" icon={<SolutionOutlined className="fs-4" />}>
              Visitor
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Santha" icon={<GoldOutlined className="fs-4" />} title="Santha">
            <Menu.Item key="santhamaster" icon={<DatabaseOutlined className="fs-4" />}>
              Santha Master
            </Menu.Item>
            <Menu.Item key="santha" icon={<FormOutlined className="fs-4" />}>
              Santha Form
            </Menu.Item>
            <Menu.Item key="santhalive" icon={<SyncOutlined className="fs-4" />}>
              Santha Live Form
            </Menu.Item>
            <Menu.Item key="donation" icon={<GiftOutlined className="fs-4" />}>
              Santha Donation Form
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Events" icon={<CalendarOutlined className="fs-4" />} title="Events">
            <Menu.Item key="event" icon={<ScheduleOutlined className="fs-4" />}>
              Event Registration
            </Menu.Item>
            <Menu.Item key="transactions" icon={<SwapOutlined className="fs-4" />}>
              Transactions
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Expense" icon={<WalletOutlined className="fs-4" />} title="Expense">
            <Menu.Item key="expense-master" icon={<DatabaseOutlined className="fs-4" />}>
              Expense Master
            </Menu.Item>
            <Menu.Item key="expense-form" icon={<FormOutlined className="fs-4" />}>
              Expense Form
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Attendance" icon={<CheckSquareOutlined className="fs-4" />} title="Attendance">
            <Menu.Item key="attendance" icon={<CheckSquareOutlined className="fs-4" />}>
              Attendance
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: '0 24px',
            background: colorBgContainer,
            fontFamily: 'Poppins, sans-serif',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            zIndex: 1,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '18px',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              background: '#f5f5f5',
            }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span style={{ fontWeight: 500, color: '#555' }}>Admin</span>
            <Avatar style={{ backgroundColor: '#c5a059' }} icon={<UserOutlined />} />
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={() => navigate('/')}
              style={{
                color: '#d9534f',
                borderColor: '#d9534f',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 500,
              }}
            >
              
            </Button>
          </div>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: isMobile ? '12px 8px' : '24px 16px',
            padding: isMobile ? 12 : 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;